<template>
  <div class="enterprise_certificate_container box_shadow_wrap">
    <a-spin :spinning="spinning">
      <div class="main">
        <div class="global_title">企业基本信息</div>
        <div class="steps_wrap">
          <a-steps :current="current" :status="status">
            <a-step v-for="(item, index) in steps" :key="item" :title="item">
              <template v-if="index == 1 && auditStatus == 2">
                <div class="ico_wrap" slot="icon">
                  <a-icon type="exclamation" />
                </div>
                <div slot="description" style="padding-right: 10px;">原因：{{auditOpinion}}</div>
              </template>
            </a-step>
          </a-steps>
        </div>
        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
          <a-form-model-item required label="公司名称" prop="companyName">
            <a-input v-model="ruleForm.companyName" :disabled="disabled" placeholder="请输入公司名称" />
          </a-form-model-item>
          <a-form-model-item required label="公司地址" prop="companyAddress">
            <a-input v-model="ruleForm.companyAddress" :disabled="disabled" placeholder="请输入公司地址" />
          </a-form-model-item>
          <a-form-model-item required label="组织机构代码" prop="organizationCode">
            <a-input v-model="ruleForm.organizationCode" :disabled="disabled" placeholder="请输入组织机构代码" />
          </a-form-model-item>
          <a-form-model-item required label="联系人" prop="contacts">
            <a-input v-model="ruleForm.contacts" :disabled="disabled" placeholder="请输入联系人" />
          </a-form-model-item>
          <a-form-model-item required label="联系电话" prop="phone">
            <a-input v-model.number="ruleForm.phone" :disabled="disabled" placeholder="请输入联系电话" />
          </a-form-model-item>
          <a-form-model-item required label="证件照片" :wrapper-col="{span: 18}" prop="certificatePicture" ref="certificatePicture" :autoLink="false">
            <div class="clearfix" v-if="!spinning">
              <bj-upload v-model="uploading" :default-list="previewList" :disabled="disabled" :action="uploadUrl" :max="5" @change="uploadList"></bj-upload>
              <div class="tips" v-if="!disabled">请上传企业证件照片</div>
            </div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>

    <div class="footer">
      <a-space :size="26">
        <template v-if="certificateStatus == 0">
          <a-button @click="goBack">取消</a-button>
          <a-button type="primary" :loading="loading" @click="submitForm">认证</a-button>
        </template>
        <template v-else-if="auditStatus == 2">
          <a-button :loading="loading" @click="handleCancel"><img class="btn_icon" src="@/assets/img/icon/revocation.png">撤销申请</a-button>
          <a-button type="primary" :loading="loading" @click="submitForm">重新提交</a-button>
        </template>
        <template v-else-if="auditStatus == 1">
          <a-button type="primary" @click="goBack"><img class="btn_icon" src="@/assets/img/icon/back.png">返回</a-button>
        </template>
        <template v-else-if="disabled">
          <a-button :loading="loading" @click="handleCancel"><img class="btn_icon" src="@/assets/img/icon/revocation.png">撤销</a-button>
          <a-button type="primary" @click="goBack"><img class="btn_icon" src="@/assets/img/icon/back.png">返回</a-button>
        </template>
      </a-space>
    </div>
  </div>
</template>
<script>
import { ApiUrl } from '@/config/index'
export default {
  data() {
    const validateCompanyName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else {
        callback();
      }
    };
    const validateCompanyAddress = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司地址'));
      } else {
        callback();
      }
    };
    const reg = /^[0-9a-zA-Z]{15}$|^[0-9a-zA-Z]{18}$/
    const validateOrganizationCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入组织机构代码'));
      } else if (!reg.test(value)) {
        callback(new Error('组织机构代码格式错误'));
      } else {
        callback();
      }
    };
    const validateContacts = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'));
      } else if (!this.$utils.test.mobile(value)) {
        callback(new Error('电话证格式错误'));
      } else {
        callback();
      }
    };
    const validateCertificatePicture = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请上传证件照片'));
      } else {
        callback();
      }
    };
    return {
      uploadUrl: `${ApiUrl}/api/backapp/system/fileUpload/oss/input`,
      queryId: '',
      auditOpinion: '',
      uploading: 'done',
      previewList: [],
      spinning: false,
      loading: false,
      ruleForm: {
        companyName: '',
        companyAddress: '',
        organizationCode: '',
        contacts: '',
        phone: '',
        certificatePicture: ''
      },
      rules: {
        companyName: [{ validator: validateCompanyName, trigger: 'change' }],
        companyAddress: [{ validator: validateCompanyAddress, trigger: 'change' }],
        organizationCode: [{ validator: validateOrganizationCode, trigger: 'change' }],
        contacts: [{ validator: validateContacts, trigger: 'change' }],
        phone: [{ validator: validatePhone, trigger: 'change' }],
        certificatePicture: [{ validator: validateCertificatePicture, trigger: 'change' }]
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8 },
      }
    }
  },
  computed: {
    auditStatus() {
      return this.$store.state.auditStatus
    },
    certificateStatus() {
      return this.$store.state.certificateStatus
    },
    disabled() {
      return this.certificateStatus == 2 && this.auditStatus != 2
    },
    steps() {
      return ['提交认证', this.auditStatus == 2 ? '驳回认证' : '认证审核','认证完成']
    },
    status() {
      return this.auditStatus == 2 ? 'error' : 'process'
    },
    current() {
      if (this.auditStatus == 1) return 2
      else if (this.certificateStatus == 2) return 1
      else return 0
    }
  },
  async created() {
    await this.getCertificationStatus()
    if (this.certificateStatus == 2) this.getCertificateInfo()
  },
  methods: {
    // 提价表单
    submitForm() {
      if (this.uploading !== 'done') return
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false

        if (this.auditStatus == 2) {
          this.resubmit()
        } else {
          this.certification()
        }
      });
    },
    // 认证
    async certification() {
      try {
        this.loading = true
        const { data: { code, msg } } = await this.$axios.enterpriseCertification({
          body: {
            companyName: this.ruleForm.companyName,  // 公司名称
            companyAddress: this.ruleForm.companyAddress, // 公司地址
            organizationCode: this.ruleForm.organizationCode, // 组织机构代码
            contacts: this.ruleForm.contacts, // 联系人
            phone: this.ruleForm.phone, // 联系电话
            certificatePicture: this.ruleForm.certificatePicture // 证件照片
          }
        })
        this.loading = false
        if (code != 0) return this.$message.error(msg)
        this.$message.success('提交成功')
        const pic = this.ruleForm.certificatePicture.split(';')
        this.initPreview(pic)
        this.getCertificationStatus()
      } catch (error) {
        this.loading = false
      }
    },
    // 重新提交
    async resubmit() {
      try {
        this.loading = true
        const { data: { code, msg } } = await this.$axios.resubmitEnterpriseCertification({
          body: {
            id: this.queryId,
            companyName: this.ruleForm.companyName,  // 公司名称
            companyAddress: this.ruleForm.companyAddress, // 公司地址
            organizationCode: this.ruleForm.organizationCode, // 组织机构代码
            contacts: this.ruleForm.contacts, // 联系人
            phone: this.ruleForm.phone, // 联系电话
            certificatePicture: this.ruleForm.certificatePicture // 证件照片
          }
        })
        this.loading = false
        if (code != 0) return this.$message.error(msg)
        this.$message.success('提交成功')
        const pic = this.ruleForm.certificatePicture.split(';')
        this.initPreview(pic)
        this.getCertificationStatus()
      } catch (error) {
        this.loading = false
      }
    },
    // 撤销认证
    handleCancel() {
      this.$confirm({
        title: '确定撤销吗?',
        confirmLoading: true,
        onOk: async () => {
          this.loading = true
          const { data: { code, msg } } = await this.$axios.enterpriseCertificationCancel({})
          this.loading = false
          if (code != 0) return this.$message.error(msg)
          this.$message.success('撤销成功')
          const pic = this.ruleForm.certificatePicture.split(';')
          this.initPreview(pic)
          this.getCertificationStatus()
        },
        onCancel: () => {
          this.loading = false
        }
      });
    },
    // 查询认证状态
    async getCertificationStatus() {
      const { data: { code, msg, body } } = await this.$axios.getCertification({})
      if (code != 0) return this.$message.error(msg)
      this.$store.commit('setCertification', body)
    },
    // 取消操作
    goBack() {
      this.$router.go(-1)
    },
    // 图片上传
    uploadList(e) {
      this.ruleForm.certificatePicture = e
      this.$refs.certificatePicture.onFieldChange()
    },
    // 认证查询
    async getCertificateInfo() {
      this.spinning = true
      const { data: { code, msg, body } } = await this.$axios.getEnterpriseCertificateInfo({})
      this.spinning = false
      if (code != 0) return this.$message.error(msg)
      
      this.queryId = body.id
      this.auditOpinion = body.auditOpinion
      this.ruleForm = {
        companyName: body.companyName,
        companyAddress: body.companyAddress,
        organizationCode: body.organizationCode,
        contacts: body.contacts,
        phone: body.phone,
        certificatePicture: body.certificatePicture
      }

      if (body.certificatePicture) {
        const pic = body.certificatePicture.split(';')
        this.initPreview(pic)
        this.$nextTick(() => {
          this.$refs.certificatePicture.onFieldChange()
        })
      }
      
    },
    // 初始化上传图片
    initPreview(arr = []) {
      this.previewList = arr.map((item, index) => ({uid: `-${index + 1}`, name: 'image.png', status: 'done', url: item}))
    }
  }
};
</script>

<style scoped lang="less">
@import '../../../styles/pages/personalcenter.less';
.enterprise_certificate_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 2px;
  min-height: calc(100% - 2px);
  .steps_wrap {
    margin: 45px 177px 58px;
  }
  .tips {
    line-height: normal;
    color: #ccc;
  }
  .footer {
    display: flex;
    justify-content: center;
  }
  .ico_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    text-align: center;
    border: 1px solid #f5222d;
    border-radius: 32px;
    transition: background-color 0.3s, border-color 0.3s;
  }
  .img_list {
    display: flex;
    flex-wrap: wrap;
    img {
      width: 104px;
      height: 104px;
      margin: 0 8px 8px 0;
    }
  }
}
.btn_icon {
  width: 16px;
  margin-right: 3px;
  vertical-align: text-bottom;
}
</style>
